import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import UserProfileEntity from "../../../../../domain/entities/UserProfileEntity";
import { Either, left, right } from "fp-ts/lib/Either";
import { Auth } from "aws-amplify";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";

const GetUserProfileApiImpl = async (userId: string): Promise<Either<ExceptionEntity, UserProfileEntity>> => {

    try {
        const baseUrl = di.get<Constants>(ConstantsName).HOST_API_USERS_URL;
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();

        const response = await fetch(`${baseUrl}/users/${userId}/profile`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
            },
        });

        if (response.status === 404) {
            return left({ message: "User not found" });
        }

        const data = await response.json();

        return right(data as UserProfileEntity);

    } catch (error: any) {
        const exception: ExceptionEntity = { message: error.message };

        return left(exception);
    }

}

export default GetUserProfileApiImpl;
